import { Menu } from "antd";
import { useEffect, useState } from "react";
import { scrollToSection } from "../animation/smoothScroll";

export const NavBar = () => {
  const [currentKey, setCurrentKey] = useState("home");

  const _handleMenuClick = (e) => {
    const element = document.getElementById(e.key);
    if (element) {
      scrollToSection(element, -60);
      setCurrentKey(e.key);
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const sections = pages.map(p => p.key);
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetBottom = offsetTop + element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetBottom) {
            setCurrentKey(section);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Menu
      style={{
        justifyContent: "end",
        padding: "8px 20px",
        border: "none",
        position: "sticky",
        top: 0,
        zIndex: 1000,
        boxShadow: "none"
      }}
      selectedKeys={[currentKey]}
      onClick={_handleMenuClick}
      mode="horizontal"
      items={pages.map((v, k) => {
        return { k, label: v.name, key: v.key };
      })}
    />
  );
};

const pages = [
  { name: "Home", key: "home" },
  { name: "About", key: "about" },
  { name: "Skills", key: "skills" },
  { name: "Projects", key: "projects" },
  { name: "GitHub", key: "github" },
  { name: "Education", key: "education" },
  { name: "Contact", key: "contact" },
];
